import { z } from "zod"

export const DjiKeychainsResponseSchema = z.object({
    result: z.object({ code: z.number(), msg: z.string() }),
    data: z.array(
        z.array(
            z.object({
                featurePoint: z.string(),
                aesKey: z.string(),
                aesIv: z.string(),
            })
        )
    ),
})

export type DjiKeychainsResponse = z.infer<typeof DjiKeychainsResponseSchema>

const DjiIntegrationLoginDataSchema = z.object({
    nick_name: z.string(),
    cookie_name: z.string(),
    cookie_key: z.string(),
    active: z.boolean(),
    email: z.string(),
    token: z.string(),
    validity: z.number(),
    user_id: z.string(),
    register_phone: z.string(),
    area_code: z.string(),
    inner_email: z.boolean(),
    subscription: z.boolean(),
    vipLevel: z.number().nullable(),
    vipInfos: z.array(z.unknown()),
    fb_v1: z.string(),
})

export type DjiSession = z.infer<typeof DjiIntegrationLoginDataSchema>

const DjiIntegrationLoginSuccessSchema = z.object({
    code: z.literal(0),
    message: z.string(),
    data: DjiIntegrationLoginDataSchema,
})

const DjiIntegrationLoginCaptchaRequiredSchema = z.object({
    code: z.literal(526),
    message: z.string(),
    data: z.null(),
})

const DjiIntegrationLoginCaptchaErrorSchema = z.object({
    code: z.literal(524),
    message: z.string(),
    data: z.null(),
})

const DjiIntegrationLoginUserNotExistSchema = z.object({
    code: z.literal(305),
    message: z.string(),
    data: z.null(),
})

export const DjiIntegrationLoginResponseSchema = z.discriminatedUnion("code", [
    DjiIntegrationLoginSuccessSchema,
    DjiIntegrationLoginCaptchaRequiredSchema,
    DjiIntegrationLoginCaptchaErrorSchema,
    DjiIntegrationLoginUserNotExistSchema,
])

const DjiIntegrationFlightFileSchema = z.object({
    Md5: z.string(),
    FileName: z.string(),
    IsFavourite: z.number(),
})

export const DjiIntegrationFlightListResponseSchema = z.object({
    Code: z.number(),
    ErrMsg: z.string(),
    FileList: z.array(DjiIntegrationFlightFileSchema),
})

export type DjiIntegrationFlightFile = z.infer<typeof DjiIntegrationFlightFileSchema>
export type DjiIntegrationFlightListResponse = z.infer<
    typeof DjiIntegrationFlightListResponseSchema
>
